import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ar from './locales/ar.json'
import tr from './locales/tr.json'



function loadLocaleMessages() {

  const locales = [{ en: en }, { ar: ar }, { tr: tr }]
  const messages = {}
  locales.forEach(lang => {
    const key = Object.keys(lang)
    messages[key] = lang[key] 
  })
  return messages
}

function getStartingLocale() {
  if (localStorage.getItem('MY_LANG_MUSACASH')) {

    if(localStorage.getItem('MY_LANG_MUSACASH') === 'ar'){
      document.body.classList.remove("ltr");
      document.body.classList.add("rtl");
    } else {
      document.body.classList.remove("rtl");
      document.body.classList.add("ltr");
    }
    
    return localStorage.getItem('MY_LANG_MUSACASH')
  }
  return "en"
}

export const _getStartingLocale = () => {
  if (localStorage.getItem('MY_LANG_MUSACASH')) {

    if(localStorage.getItem('MY_LANG_MUSACASH') === 'ar' ){
      document.body.classList.remove("ltr");
      document.body.classList.add("rtl");
    } else {
      document.body.classList.remove("rtl");
      document.body.classList.add("ltr");
    }
    
    return localStorage.getItem('MY_LANG_MUSACASH')
  }
  return "en"
}

export const _changeSwitchLang = (lang) => {
  // console.log("change", lang)
  // console.log("change", localStorage.getItem('MY_LANG_MUSACASH'))
  // if (localStorage.getItem('MY_LANG_MUSACASH')) {
    if (localStorage.getItem('MY_LANG_MUSACASH') !== lang) {
      localStorage.setItem("MY_LANG_MUSACASH", lang);
      if(lang === 'ar'){
        document.body.classList.remove("ltr");
        document.body.classList.add("rtl");
      } else {
        document.body.classList.remove("rtl");
        document.body.classList.add("ltr");
      }
      setTimeout(() => {
        location.reload();
      }, 100);
    }
  // }
}

export default createI18n({
  locale: getStartingLocale() || 'en', //localStorage.getItem('MY_LANG_MUSACASH') || 'en',
  fallbackLocale: getStartingLocale() || 'en', //localStorage.getItem('MY_LANG_MUSACASH') || 'en',
  messages: loadLocaleMessages()
})